import React from "react";
import aggregateStyles from "./ProfileOportunidades.module.scss";
import styles from "../PerfilMain.module.scss";
import MisProyectos from "../MisProyectos/MisProyectos";
import MisCotizacionesDeMateriales from "../MisCotizacionesDeMateriales/MisCotizacionesDeMateriales.js";

type OportunidadesSection = "proyectos" | "materiales";

interface ProfileOportunidadesProps {
  section: OportunidadesSection;
  onSectionChange: (section: OportunidadesSection) => void;
  myPerson: boolean;
  perfilAjeno?: string | number;
  userData: any;
  profileVisualizerData: any;
  setInfoReady: (ready: boolean) => void;
}

const ProfileOportunidades: React.FC<ProfileOportunidadesProps> = ({
  section,
  onSectionChange,
  myPerson,
  perfilAjeno,
  userData,
  profileVisualizerData,
  setInfoReady,
}) => {
  return (
    <div className={styles.sectionContent}>
      <div className={aggregateStyles.subTabs} role="tablist" aria-label="Secciones de oportunidades">
        <button
          type="button"
          role="tab"
          aria-selected={section === "proyectos"}
          className={`${aggregateStyles.subTab} ${section === "proyectos" ? aggregateStyles.subTabActive : ""}`}
          onClick={() => onSectionChange("proyectos")}
        >
          Proyectos publicados
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={section === "materiales"}
          className={`${aggregateStyles.subTab} ${section === "materiales" ? aggregateStyles.subTabActive : ""}`}
          onClick={() => onSectionChange("materiales")}
        >
          Solicitud de materiales
        </button>
      </div>
      {section === "proyectos" && (
        <MisProyectos
          fromPage
          myPerson={myPerson}
          perfilAjeno={perfilAjeno}
          userData={userData}
          setInfoReady={setInfoReady}
          currentTab="Oportunidades"
        />
      )}
      {section === "materiales" && (
        <MisCotizacionesDeMateriales
          myPerson={myPerson}
          setInfoReady={setInfoReady}
          profileVisualizerData={profileVisualizerData}
          profileReturnTab="Oportunidades"
        />
      )}
    </div>
  );
};

export default ProfileOportunidades;
